import {
  DescriptionListTBody,
  DescriptionListTd,
  DescriptionListTr,
  DotsDescriptionListTable,
} from "dots-ui/components/dotsDescriptionList";
import {
  IAvisEditableListFieldArrayProps,
  IEditableListRowState,
} from "../../types";
import AvisEditableListFields from "../AvisEditableListFields";
import { AvisEditableListAddButton } from "../actions/AvisEditableListAddButton";

export function AvisEditableListDescriptionList<
  T extends object,
  P extends IEditableListRowState,
>(props: Readonly<IAvisEditableListFieldArrayProps<T, P>>): JSX.Element {
  const { bag, bagField } = props;

  const rowCount = (bag.values[bagField] as P[])?.length;

  return (
    <DotsDescriptionListTable className="col-12" gridLines="rows-only">
      <DescriptionListTBody>
        <DescriptionListTr>
          <DescriptionListTd className="outer-row">
            <div>
              <AvisEditableListAddButton key="add-1" {...props} />
              <AvisEditableListFields<T, P> {...props} key="fields" />
              {rowCount > 2 && (
                <AvisEditableListAddButton key="add-2" {...props} />
              )}
            </div>
          </DescriptionListTd>
        </DescriptionListTr>
      </DescriptionListTBody>
    </DotsDescriptionListTable>
  );
}
